"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _reactTether = _interopRequireDefault(require("react-tether"));

var _SelectWrapper = _interopRequireDefault(require("../SelectWrapper"));

var _styles = _interopRequireDefault(require("./styles"));

// This exists to combine the functionality of react-select, and react-tether. It requires some overriding of react-select.
var TetheredSelect =
/*#__PURE__*/
function (_ReactSelect) {
  (0, _inherits2["default"])(TetheredSelect, _ReactSelect);

  function TetheredSelect(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, TetheredSelect);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(TetheredSelect).call(this, props));
    _this.renderOuter = _this._renderOuter; // eslint-disable-line no-underscore-dangle

    return _this;
  }

  (0, _createClass2["default"])(TetheredSelect, [{
    key: "_renderOuter",
    value: function _renderOuter() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      // eslint-disable-line no-underscore-dangle
      var menu = (0, _get2["default"])((0, _getPrototypeOf2["default"])(TetheredSelect.prototype), "renderOuter", this).apply(this, args);

      if (!menu) {
        return null;
      } // this.wrapper comes from the ref of the main Select component


      var selectWidth = this.wrapper ? this.wrapper.offsetWidth : null;
      return _react["default"].createElement(_reactTether["default"], {
        classPrefix: "tether-select",
        renderElementTo: "body",
        attachment: "top left",
        targetAttachment: "top left",
        constraints: [{
          to: 'window',
          attachment: 'together',
          pin: ['top']
        }]
      }, _react["default"].createElement("div", null), _react["default"].cloneElement(menu, {
        style: {
          position: 'static',
          width: selectWidth
        }
      }));
    }
  }]);
  return TetheredSelect;
}(_reactSelect["default"]);

var Select = function Select(props) {
  var select = props.tether ? TetheredSelect : _reactSelect["default"];
  return _react["default"].createElement(_SelectWrapper["default"], (0, _extends2["default"])({}, props, {
    styles: _styles["default"],
    selectedSelect: select
  }));
};

var _default = Select;
exports["default"] = _default;
Select.propTypes = {
  tether: _propTypes["default"].bool
};